import { createClient } from '@supabase/supabase-js'

export default {
  useReset: true,
  useVariable: true,
  useFontImport: true,
  useIconSprite: true,
  useSvgSprite: true,
  useDefaultConfig: true,
  useDocumentTheme: true,
  globalTheme: 'light',
  verbose: false,
  fetch: {
    adapter: 'supabase',
    createClient,
    url: 'https://ighhbtzddnmzvlsfoxnb.supabase.co',
    key: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlnaGhidHpkZG5tenZsc2ZveG5iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4NDc5ODksImV4cCI6MjA4OTQyMzk4OX0.15jwVnzHSizO_-HfC1vQLxAT0SzXJkbGs-nps6Zm_v4',
    db: {
      schema: 'public'
    },
    retry: { retry: '3', delay: '1000' }
  },
  polyglot: {
    defaultLang: 'en',
    languages: ['en', 'ka', 'ru', 'uk', 'tr', 'zh', 'hi', 'msa'],
    storageLangKey: 'dental_lang',
    storagePrefix: 'dental_t_'
  }
}
